export class PostMigrateAdjustment {
    public constructor(init?: Partial<PostMigrateAdjustment>) {
      Object.assign(this, init);
    }
     invoiceNumber: string;
   }